import Dice from '../image/dice.svg'
import Quote from '../image/quote-.svg'
import Creator from '../image/people.svg'
import { Link } from 'react-router-dom'

const LandingButtons = () => {
    return ( 
        
        <div className='landing-buttons'>
                {/* <Link to='/browse'><span>Genres</span> </Link> */}
                <Link to='/random-book'><span>Random Book</span></Link>
                <Link to='/browse'><span>Browse</span> </Link>
                
                {/* <Link to=''><button className='single-landing-button' id='creator-landing-button'><img src={Creator}/> <span>Creator</span> </button></Link> */}
        </div>
     );
}
 
export default LandingButtons;
